import { render, staticRenderFns } from "./LoteDeProducao.vue?vue&type=template&id=448fb2db&scoped=true&lang=pug"
import script from "./LoteDeProducao.vue?vue&type=script&lang=js"
export * from "./LoteDeProducao.vue?vue&type=script&lang=js"
import style0 from "./LoteDeProducao.vue?vue&type=style&index=0&id=448fb2db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fb2db",
  null
  
)

export default component.exports